<tr>
  <td>
    <div
      class="is-pulled-left"
      style="width:120px;height:120px;margin-right:20px;"
    >
      {#if item.data.images?.[0]}
      <img
        src={item.data.images[0]}
        style="height:120px;width:120px;object-fit:cover;object-position:center;"
        alt={item.data.name}
        loading="lazy"
      />
      {:else}
      <img
        src="/assets/img/box.png"
        style="height:120px;width:120px;background-color:lightgrey"
        alt="placeholder"
        loading="lazy"
      />
      {/if}
    </div>
    <div>
      <a href={$url('../../offer/' + item.id)}>{item.data.name || '<No name>'}</a>
    </div>
    <div class="is-line-clamp-4">
     {item.data.description}
    </div>
  </td>
  
  <td style="width:10%;">
    {#if item.data.status === 'published'}
      <p class="has-text-left">
        {dayjs(item.data.published).format('YYYY/MM/DD HH:mm')}
      </p>
    {/if}
    {#if item.data.status === 'pending-approval'}
      <!-- svelte-ignore a11y-missing-attribute -->
      <a on:click={() => {
      $uiState.activeModal = { component: ConfirmApprove, props: { item } };
      }}>Approve</a>
    {/if}
  </td>
  {#if item.data.status === 'published'}
    <td style="width:10%;">
      {#if item.data.requests && item.data.requests.length > 0}
        
          {`${item.data.requests.length} request${isMultipleRequest ? 's' : ''}`}
        
      {/if}
    </td>
  {/if}
</tr>

<script lang="ts">

  export let item: Offer_v2_Doc;

  import { url } from '@sveltech/routify';
  import dayjs from 'dayjs';
  import { uiState } from "../../../../lib/uiState";
  import ConfirmApprove from './ConfirmApprove.svelte';

  $: isMultipleRequest = item.data.requests?.length > 1

</script>
